import { useState } from "react";
import { LayoutGrid, Rss } from "lucide-react";
import { T, sans, HeaderStrip } from "../operator/OperatorPage";
import { AgentGalleryView } from "./AgentGalleryView";
import { AgentStreamView } from "./AgentStreamView";

type ViewMode = "cards" | "feed";

export function AgentsPage() {
  const [view, setView] = useState<ViewMode>("cards");

  return (
    <div
      style={{
        background: T.bg,
        padding: "16px",
        height: "100%",
        fontFamily: sans,
        color: T.ink,
        display: "flex",
        flexDirection: "column",
        gap: 12,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          flexShrink: 0,
        }}
      >
        <div style={{ flex: 1 }}>
          <HeaderStrip
            subtitle={view === "cards" ? "Agents · cards" : "Agents · feed"}
          />
        </div>
      </div>

      {/* View toggle — segmented control */}
      <div
        style={{
          display: "inline-flex",
          alignSelf: "flex-start",
          background: T.panel,
          border: `1px solid ${T.line}`,
          borderRadius: 8,
          padding: 3,
          flexShrink: 0,
        }}
      >
        {(
          [
            { id: "cards", label: "Cards", Icon: LayoutGrid },
            { id: "feed", label: "Feed", Icon: Rss },
          ] as const
        ).map(({ id, label, Icon }) => {
          const active = view === id;
          return (
            <button
              key={id}
              onClick={() => setView(id)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "6px 14px",
                background: active ? T.skyDark : "transparent",
                color: active ? "#fff" : T.ink2,
                border: "none",
                borderRadius: 6,
                fontFamily: sans,
                fontSize: 12,
                fontWeight: 600,
                cursor: "pointer",
                transition: "background 0.15s ease, color 0.15s ease",
              }}
            >
              <Icon size={14} />
              {label}
            </button>
          );
        })}
      </div>

      {view === "cards" ? <AgentGalleryView /> : <AgentStreamView />}
    </div>
  );
}

(AgentsPage as unknown as { path: string }).path = "/agents";
